import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    entities: [],
    loading: 'idle',
    error: null
};
export var CompletedOrdersActionType;
(function (CompletedOrdersActionType) {
    CompletedOrdersActionType["FetchCompletedOrders"] = "completedOrders/fetchCompletedOrders";
    CompletedOrdersActionType["RefreshCompletedOrders"] = "completedOrders/refreshCompletedOrders";
})(CompletedOrdersActionType || (CompletedOrdersActionType = {}));
export const fetchCompletedOrders = createAsyncThunk(CompletedOrdersActionType.FetchCompletedOrders, (requestData, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { api } = getState().config;
        const args = {
            business_date: requestData.business_date,
            prep_status: `COMPLETED,FULFILLED`
        };
        if (requestData.channelTypes)
            args.channel_type = requestData.channelTypes;
        const orders = yield api.getOrders(args);
        return orders;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const completedOrdersSlice = createSlice({
    name: ReducerType.CompletedOrders,
    initialState,
    reducers: {
        resetCompletedOrders: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCompletedOrders.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchCompletedOrders.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchCompletedOrders.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetCompletedOrders } = completedOrdersSlice.actions;
export const selectCompletedOrders = (state) => {
    const { entities: orders, loading, error } = state.completedOrders;
    return { orders, loading, error };
};
export const completedOrdersReducer = completedOrdersSlice.reducer;
